import { FilmPromotedTagType } from '../types/type';
export const getLabelForTagType = (type, displayText) => {
    const { comingSoonLabel, preBookNowLabel, sponsoredLabel } = displayText;
    switch (type) {
        case FilmPromotedTagType.ComingSoon:
            return comingSoonLabel;
        case FilmPromotedTagType.PreBookNow:
            return preBookNowLabel;
        case FilmPromotedTagType.Sponsored:
            return sponsoredLabel;
        default:
            throw new Error(`Cannot get label for unknown FilmPromotedTagType '${type}'.`);
    }
};
